import { useEffect, useState } from 'react';
import icons from 'style';
import KeycloakApi from 'api/KeycloakApi';
import { useDataFetcher } from 'hooks/useDataFetcher/useDataFetcher';
import { useGlobalNetworkError, useGlobalNoInternet } from 'hooks/withNetworkCheck/withNetworkCheck';
import { StreamSessionsDetailsResponse } from 'types/Player';

export type DeviceToRemove = { id: string; bySessionId: boolean };

export enum DeviceType {
    mobile = 'mobile',
    tablet = 'tablet',
    computer = 'computer',
    tv = 'tv',
    stb = 'stb',
}

export const getDeviceIcon = (screenType?: string, deviceType?: string, deviceFamily?: string) => {
    const type = (screenType || deviceType || deviceFamily || '').toLowerCase();

    switch (type) {
        case DeviceType.mobile:
            return icons.icoDevicePhone;
        case DeviceType.tablet:
            return icons.icoDeviceTablet;
        case DeviceType.computer:
        case 'browser':
        case 'mac':
            return icons.icoDeviceDesktop;
        case DeviceType.stb:
        case DeviceType.tv:
            return icons.icoDeviceTv;
        default:
            return icons.icoDeviceDesktop;
    }
};

export const useDeviceManagement = (drmRegistered?: boolean) => {
    const { onNoInternet } = useGlobalNoInternet();
    const { onNetworkError } = useGlobalNetworkError();
    const [deviceToRemove, setDeviceToRemove] = useState<DeviceToRemove | null>(null);

    const {
        response,
        error: fetchError,
        loading: fetchLoading,
        fetcher: getAllDevices,
    } = useDataFetcher<StreamSessionsDetailsResponse[], null>(
        () => KeycloakApi.getDeviceSessions(drmRegistered),
        onNoInternet,
        onNetworkError
    );

    const {
        error: removeError,
        fetcher: removeDevice,
        responseCode: removeResponseCode,
    } = useDataFetcher<any, DeviceToRemove>(
        (params) =>
            params.bySessionId
                ? KeycloakApi.deleteSessionById(params.id, drmRegistered)
                : KeycloakApi.deleteSessionDevice(params.id, drmRegistered),
        onNoInternet,
        onNetworkError
    );

    const devices: StreamSessionsDetailsResponse[] = response ?? [];

    const fetchDevices = () => {
        getAllDevices(null);
    };

    useEffect(() => {
        fetchDevices();
    }, []);

    return {
        devices,
        fetchLoading,
        fetchError,
        fetchDevices,
        deviceToRemove,
        setDeviceToRemove,
        removeDevice,
        removeError,
        removeResponseCode,
    };
};
